import { render } from "./Favourites.vue?vue&type=template&id=1d216faa&scoped=true"
import script from "./Favourites.vue?vue&type=script&lang=js"
export * from "./Favourites.vue?vue&type=script&lang=js"

import "./Favourites.vue?vue&type=style&index=0&id=1d216faa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d216faa"

export default script